module.exports = __webpack_public_path__ + "static/img/Fremantle.c371d2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Fremantle.jpg
// module id = m9SP
// module chunks = 1